export default {
  data () {
    return {
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
    }
  },
  created () {
    this.getQueryUrl()
    this.getList()
  },
  mounted() {
  },
  methods: {
    getQueryUrl() {
      const { offset, limit } = this.$route.query
      // 处理数组形式参数
      this.form = {...this.form,...this.$route.query}
      offset && (this.offset = parseInt(offset))
      limit && (this.limit = parseInt(limit))
    },
    onSearch(form) {
      this.form = form
      this.offset = 0
      this.getList()
    },
    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    }
  }
}
